import { addCustomer, addCustomerInCompanyId, AssignChildCompanyId, deleteCustomerById, getAllCustomer, getCustomerById, updateCustomer } from "../../../helpers/backend_helper";
import { CustomerByCompanyIdError, CustomerByCompanyIdRequest, CustomerByCompanyIdSuccess } from "../Company/reducer";
import { AssignChildIdError, AssignChildIdRequest, AssignChildIdSuccess, customerError, customerRequest, customerSuccess, getCustomerByIdError, getCustomerByIdRequest, getCustomerByIdSuccess } from "./reducer";

export const fetchCustomer = (page:number,count:number,keyword:string,status:string,companyId?:string,) => async (dispatch: any) => {
    dispatch(customerRequest());
    try {
      const response: any = await getAllCustomer(page,count,keyword,status,companyId);
      if (response && response.isSuccess) {
        dispatch(customerSuccess(response.data));
        return response
      } else {
        dispatch(customerError("Failed to fetch Customer"));
      }
    } catch (error: any) {
      dispatch(customerError(error.message));
    }
  };


    
    export const addNewCustomer = (data: any) => async (dispatch: any) => {
      dispatch(customerRequest());
      try {
        const response: any = await addCustomer(data);
        if (response && response.data) {
          dispatch(customerSuccess(response.data));
          return response 
        } else {
          dispatch(customerError("Failed to add Customer"));
        }
      } catch (error: any) {
        dispatch(customerError(error.message));
      }
    };
    
    export const editCustomer = (data: any) => async (dispatch: any) => {
      dispatch(customerRequest());
      try {
        const response: any = await updateCustomer(data);
        if (response && response.data) {
          dispatch(customerSuccess(response.data));
          return response
        } else {
          dispatch(customerError("Failed to edit Customer"));
        }
      } catch (error: any) {
        dispatch(customerError(error.message));
      }
    };
   
    export const fetchCustomerById = (customerId: string) => async (dispatch: any) => {
      dispatch(getCustomerByIdRequest());
      try {
        const response: any = await getCustomerById(customerId);  
    
        if (response && response.isSuccess) {
          dispatch(getCustomerByIdSuccess(response.data)); 
          return response;  
        } else {
          dispatch(getCustomerByIdError("Failed to fetch Customer by ID"));
          return null; 
        }
      } catch (error: any) {
        dispatch(getCustomerByIdError(error.message));  
        return null;
      }
    };

 export const deleteCustomer = (id: string) => async (dispatch: any) => {
    dispatch(customerRequest());
    try {
      const response: any = await deleteCustomerById(id);  
  
      if (response && response.isSuccess) {
        dispatch(customerSuccess(response.data)); 
        return response;
      } else {
        dispatch(customerError("Failed to fetch Customer by ID"));
        return response; 
      }
    } catch (error: any) {
      dispatch(customerError(error.message));  
      return null;
    }
  }   

  export const assignChild =
  (customerId: string | undefined, additionalInfo: any[]) => async (dispatch: any) => {
    dispatch(AssignChildIdRequest());

    try {
      
      let data: any = {
        customerId: customerId,
        additionalInfo: additionalInfo,
      };
      const response: any = await AssignChildCompanyId(data);

      if (response && response.isSuccess) {
        dispatch(AssignChildIdSuccess(response.data));
        return response;
      } else {
        dispatch(
          AssignChildIdError(
            response?.message || "Failed to fetch customers by Company ID"
          )
        );
        return response;
      }
    } catch (error: any) {
      console.error("Error in getCustomerByCompanyId thunk:", error);
      dispatch(AssignChildIdError(error.message));
      return null;
    }
  };